var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13317_67449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48743 13.856V19.0652C3.48743 19.3048 3.29295 19.4993 3.05333 19.4993H1.31692C1.07729 19.4993 0.882812 19.3048 0.882812 19.0652V13.856C0.882812 13.6164 1.07729 13.4219 1.31692 13.4219H3.05333C3.29295 13.4219 3.48743 13.6164 3.48743 13.856Z",
    fill: "#794CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69837 12.1197V19.0653C8.69837 19.1803 8.65278 19.291 8.57117 19.3724C8.48999 19.4538 8.37931 19.4994 8.26426 19.4994H6.52785C6.41281 19.4994 6.30212 19.4538 6.22094 19.3724C6.13934 19.291 6.09375 19.1803 6.09375 19.0653V12.1197C6.09375 12.0046 6.13934 11.8939 6.22094 11.8125C6.30212 11.7311 6.41281 11.6855 6.52785 11.6855H8.26426C8.37931 11.6855 8.48999 11.7311 8.57117 11.8125C8.65278 11.8939 8.69837 12.0046 8.69837 12.1197Z",
    fill: "#794CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9054 10.3829V19.0654C13.9054 19.18 13.8598 19.2907 13.7782 19.3721C13.697 19.4535 13.5863 19.4991 13.4713 19.4991H11.7349C11.6198 19.4991 11.5092 19.4535 11.428 19.3721C11.3464 19.2907 11.3008 19.18 11.3008 19.0654V10.3829C11.3008 10.2683 11.3464 10.1576 11.428 10.0762C11.5092 9.9948 11.6198 9.94922 11.7349 9.94922H13.4713C13.5863 9.94922 13.697 9.9948 13.7782 10.0762C13.8598 10.1576 13.9054 10.2683 13.9054 10.3829Z",
    fill: "#794CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1163 6.91067V19.0655C19.1163 19.3052 18.9219 19.4996 18.6822 19.4996H16.9458C16.7062 19.4996 16.5117 19.3052 16.5117 19.0655C16.5117 16.5712 16.5117 9.40501 16.5117 6.91067C16.5117 6.67104 16.7062 6.47656 16.9458 6.47656H18.6822C18.9219 6.47656 19.1163 6.67104 19.1163 6.91067Z",
    fill: "#794CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7637 1.36821L10.8659 7.26593L8.56823 4.96822C8.39892 4.79849 8.12371 4.79849 7.95441 4.96822L1.87697 11.0457C1.70768 11.215 1.70768 11.4902 1.87697 11.6595C2.04628 11.8288 2.32149 11.8288 2.49079 11.6595L8.26132 5.88895L10.559 8.18666C10.7283 8.35639 11.0035 8.35639 11.1728 8.18666L17.3775 1.98203V3.53872C17.3775 3.77835 17.572 3.97282 17.8116 3.97282C18.0512 3.97282 18.2457 3.77835 18.2457 3.53872V0.934103C18.2457 0.694477 18.0512 0.5 17.8116 0.5H15.207C14.9673 0.5 14.7729 0.694477 14.7729 0.934103C14.7729 1.17373 14.9673 1.36821 15.207 1.36821H16.7637Z",
    fill: "#794CD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13317_67449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart .383b6be851e8f7a4146e8c3f39847d71.svg";
export { ForwardRef as ReactComponent };